import ChatGPT from "../components/chat/ChatGPT";

export default function Chat() {
  
  return (
    <ChatGPT />
  );
};
